
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/config";
import { Layout } from "./components/Layout";
import Index from "./pages/Index";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Partners from "./pages/Partners";
import Pricing from "./pages/Pricing";
import FAQs from "./pages/FAQs";
import Contact from "./pages/Contact";
import RequestDemo from "./pages/RequestDemo";
import LearnMore from "./pages/LearnMore";
import TelecomUseCase from "./pages/TelecomUseCase";
import ManufacturingUseCase from "./pages/ManufacturingUseCase";
import InspectionsUseCase from "./pages/InspectionsUseCase";
import ChecklistsUseCase from "./pages/ChecklistsUseCase";
import BarcodeScanningUseCase from "./pages/BarcodeScanningUseCase";
import SLAManagementUseCase from "./pages/SLAManagementUseCase";
import AssetManagementUseCase from "./pages/AssetManagementUseCase";
import TaskManagementUseCase from "./pages/TaskManagementUseCase";
import CustomPrice from "./pages/Custom-Price";
import SuccessStories from "./pages/SuccessStories";

const queryClient = new QueryClient();

const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Index />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/faqs" element={<FAQs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/request-demo" element={<RequestDemo />} />
                <Route path="/learn-more" element={<LearnMore />} />
                <Route path="/telecom" element={<TelecomUseCase />} />
                <Route path="/manufacturing" element={<ManufacturingUseCase />} />
                <Route path="/inspections" element={<InspectionsUseCase />} />
                <Route path="/checklists" element={<ChecklistsUseCase />} />
                <Route path="/barcode-scanning" element={<BarcodeScanningUseCase />} />
                <Route path="/sla-management" element={<SLAManagementUseCase />} />
                <Route path="/asset-management" element={<AssetManagementUseCase />} />
                <Route path="/task-management" element={<TaskManagementUseCase />} />
                <Route path="/custom-price" element={<CustomPrice />} />
                <Route path="/success-stories" element={<SuccessStories />} />
                {/* Redirect from old routes */}
                <Route path="/customer-price" element={<Navigate to="/custom-price" />} />
                <Route path="/customer-price2" element={<Navigate to="/custom-price" />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
};

export default App;
